import { commaFormat } from 'components/features/new-report/utils/formatter';
import {
  portfolioTypeToBackgroundColor,
  portfolioTypeToString,
} from 'components/features/target-achievement-support/utils/portfolioInfo';
import { PortfolioAnalysisItem } from 'components/features/target-achievement-support/utils/type';
import React from 'react';

type Props = {
  portfolio: PortfolioAnalysisItem;
  className?: string;
};

export const PortfolioPercentageTransition = (
  props: Props
): React.ReactElement => {
  const percentageColor =
    props.portfolio.currentPer >= props.portfolio.targetPer
      ? 'text-bluegray-500'
      : 'text-teal-500';

  return (
    <>
      <div className={`flex flex-row items-center ${props.className ?? ''}`}>
        <div className="flex flex-row items-center">
          <div
            className="rounded-full w-3 h-3"
            style={{
              backgroundColor: portfolioTypeToBackgroundColor(
                props.portfolio.assetType
              ),
            }}
          />
          <div className="ml-2 font-bold text-bluegray-700 text-xl">
            {portfolioTypeToString(props.portfolio.assetType)}
          </div>
        </div>
        <div
          className="ml-auto grid col-gap-2 text-bluegray-700"
          style={{
            gridTemplateColumns: 'auto auto auto',
            placeItems: 'center',
          }}>
          <div className="text-xs" style={{ gridColumn: '1', gridRow: '1' }}>
            現在
          </div>
          <div className="text-xs" style={{ gridColumn: '3', gridRow: '1' }}>
            目標
          </div>
          <div
            className="flex flex-row items-baseline"
            style={{ gridColumn: '1', gridRow: '2' }}>
            <div className="font-normal text-2xl">
              {commaFormat(props.portfolio.currentPer, {
                numberOfDecimals: 0,
              })}
            </div>
            <div className="font-normal text-xs">%</div>
          </div>
          <div
            className="text-bluegray-300 text-2xl icon-chevrons-right"
            style={{ gridColumn: '2', gridRow: '2' }}></div>
          <div
            className="flex flex-row items-baseline"
            style={{ gridColumn: '3', gridRow: '2' }}>
            <div className={`font-normal text-2xl ${percentageColor}`}>
              {commaFormat(props.portfolio.targetPer, {
                numberOfDecimals: 0,
              })}
            </div>
            <div className="font-normal text-xs">%</div>
          </div>
        </div>
      </div>
    </>
  );
};
